import Vue from 'vue'
import {
  ACCESS_TOKEN,
  USER_INFO_KEY,
  ACCESS_VERSION_MESSAGE,
  ACCESS_CLOUD_TOKEN,
  FOREIGN_CITY_LIST, SET_CITY_FLAG
} from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import HttpServices from '@/api/service/HttpServices'
import CitiesHelper from '@/utils/helper/citiesHelper'
import dbManager from '@/utils/indexeDb'
import PermissionsHelper from '@/utils/permissionsHelper'
import store from '@/store'
import { clearProjectStorage } from '@/utils/storage'
function handleUserInfo(commit, res, resolve) {
  const token = Vue.ls.get(ACCESS_TOKEN)
  commit('SET_TOKEN', token)
  commit('SET_ROLES', res.result.role)
  commit('SET_INFO', res.result)
  commit('SET_NAME', {
    name: res.result.merchantName,
    welcome: welcome()
  })
  let userUrl = 'https://imgb.woyoubooking.com/common/hotel/user_default_icon.png' //默认头像
  if (res.result.shopLogo) {
    userUrl = res.result.shopLogo
  }
  commit('SET_AVATAR', userUrl)
  resolve(res)
}

// 获取国外城市
function GetforeignCity(commit) {
  CitiesHelper.getForeignCitList().then(list => {
    commit('SET_FOREIGN_CITY', list)
  })
}

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
    platformInfo: {},
    versionInfo: {
      versionLimit: 0,
      versionId: 0,
      versionRouteList: []
    },
    independentPay: false,
    foreignCityList: [],
    ownSwitch: false,
    authorizedUserName: '--',//服务授权名
    sortCount: undefined,
    sortDrawn: undefined,
    sortCash: undefined,
    h5DomainUrl: '',
    systemService: {},
    merchantField:{
      merchantType:0,
      productCatalogList:[]
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_AUTHORIZED_USER_NAME: (state, authorizedUserName) => {
      state.authorizedUserName = authorizedUserName
    },
    SET_NAME: (state, {
      name,
      welcome
    }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_VERSION_INFO: (state, info) => {
      state.versionInfo = info
    },
    SET_PAY_INDEPENDENT: (state, flag) => {
      state.independentPay = flag
    },
    SET_FOREIGN_CITY: (state, list) => {
      state.foreignCityList = list
    },
    SET_PAY_OWNSWITCH: (state, flag) => {
      state.ownSwitch = flag
    },
    SET_FEE_COUNT: (state, type) => {
      state.sortCount = type
    },
    SET_WIDTH_DRAWN: (state, type) => {
      state.sortDrawn = type
    },
    SET_DRAWN_CASH: (state, type) => {
      state.sortCash = type
    },
    SET_H5_DOMAIN: (state, url) => {
      state.h5DomainUrl = url
    },
    SET_SYSTEM_SERVICE: (state, systemService) => {
      state.systemService = systemService
    },
    SET_MERCHANT_FIELD:(state,merchantField)=>{
      state.merchantField = merchantField
    }
  },

  actions: {
    // 登录
    Login({ commit }, params) {
      return new Promise((resolve, reject) => {
        HttpServices.getUserService().post('merchant/v2/operate/merchantInfoLogin', params)
          .then(res => {
            if (res.merchantLoginType === 0) { //总后台
              reject({
                msg: '账号密码错误'
              })
            } else if (res.account >= 3) {
              Vue.ls.set(ACCESS_TOKEN, res.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO_KEY, res, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', res.token)
              resolve(res)
            } else {
              reject({
                msg: '账号密码错误'
              })
            }
          }).catch(reason => reject(reason))
      })
    },

    // 获取用户信息
    GetInfo({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        HttpServices.getPermissionService().get('permission/v2/selectMenusByUserId')
          .then(info => {
            const userInfo = Vue.ls.get(USER_INFO_KEY)
            const res = {
              result: {
                role: {
                  permissionAll: false
                },
                ...userInfo
              }
            }
            //商户级（所有允许的权限）
            const merchantPermissionList = info.defaultMerchantMenuJson.split(',')
            // info.subAccountType>3 说明是子账号
            if (info.subAccountType > 3) {
              //这里的菜单权限需要再次动态过滤符合范围（当前商户拥有的权限）
              res.result.role.permissionList = info.menuList.filter(mKey=>merchantPermissionList.includes(mKey))
              handleUserInfo(commit, res, resolve)
            } else {
              //白名单
             // const list=['VerificationList','FirstRechargeList','StudentVerify','BalanceReconciliation','ZwyHome','ZwyRushHome','RechargeRecord', 'WithdrawalRecord','SupplyChain','ShiJiHome','CouponList','CtripHome','QianqingHome','SamHome']
              res.result.role.permissionList=[...merchantPermissionList]
              // console.error('----permissionList-----',`${merchantPermissionList.length}个页面`,merchantPermissionList)
              //AllPermission 权限配置页面
              const isDev= process.env.NODE_ENV === 'development'
              if(isDev){
                res.result.role.permissionList.push('AllPermission')
              }
              handleUserInfo(commit, res, resolve)
              // dispatch('GeAllPermissionList')
              //   .then(list => {
              //     res.result.role.permissionList = list
              //     handleUserInfo(commit, res, resolve)
              //   }).catch(reason => reject(reason))
            }
            dispatch('GetSystemServiceExpireTip');//服务提示信息
          }).catch(reason => reject(reason))
      })
    },
    GetSystemServiceExpireTip({ commit }) {
      const url = 'api/v2/versionInformation/getSystemServiceExpireTip'
      HttpServices.getUserService().post(url, {})
        .then(list => {
          commit('SET_SYSTEM_SERVICE',list)
        })
        .catch(reason => {
          console.error('===getSystemServiceExpireTip==', reason)
        })
    },
    // 查询版本权限信息
    GetPermissions({commit}) {
      return new Promise((resolve, reject) => {
        HttpServices.getUserService().post('api/v2/versionInformation/permissionsDetails').then(res => {
          if (res) {
            let text = res.informationId + ',' + res.versionMerchantStatus
            Vue.ls.set(ACCESS_VERSION_MESSAGE, text, 7 * 24 * 60 * 60 * 1000)
            let pastList = []
            if (res.versionPermissionsExpiredVos && res.versionPermissionsExpiredVos.length > 0) {
              pastList = res.versionPermissionsExpiredVos.map((item) => {
                return item.expiredCode
              })
              // console.log("pastList",pastList)
            }
            let versionInfo = new Object
            versionInfo.versionLimit = res.versionMerchantStatus
            versionInfo.versionId = res.informationId
            versionInfo.versionRouteList = pastList
            commit('SET_VERSION_INFO', versionInfo)
            // 国外城市
            GetforeignCity(commit)
            resolve(res)
          }
        }).catch(reason => reject(reason))
      })
    },
    GetCloudToken({ commit }, params) {
      return new Promise((resolve, reject) => {
        HttpServices.getCloudUserService().post('merchant/login', params).then(res => {
          if (res) {
            Vue.ls.set(ACCESS_CLOUD_TOKEN, res.cloudToken, 7 * 24 * 60 * 60 * 1000)
            resolve(res)
          }
        })
      }).catch(reason => reject(reason))
    },
    // 获取是否独立支付
    GetPayOwn({ commit,state},res) {
      return new Promise((resolve, reject) => {
        HttpServices.getUserService().post('api/v2/paySetUp/query/own').then(res => {
          // console.log("GetPayOwn===commit",res)
          if (res != null) {
            commit('SET_PAY_INDEPENDENT', res.own)
            commit('SET_PAY_OWNSWITCH', res.ownSwitch)
            resolve(res)
          }
        }).catch(reason => resolve(reason.data))
      })
    },
    /**
     * 获取需要隐藏的路由信息
     * @param commit
     * @param userInfo
     * @returns {Promise<unknown>}
     * @constructor
     */
    GetHiddenPermissionList({ commit },userInfo){
      const {merchantId} = userInfo;
      const {platformId} = store.getters.platformConfig
      return new Promise((resolve, reject) => {
        PermissionsHelper.getHiddenPermissionInfo(merchantId,platformId)
          .then(res=>{
            commit('SET_PAY_INDEPENDENT', res.own)
            commit('SET_PAY_OWNSWITCH', res.ownSwitch)
            commit('SET_MERCHANT_FIELD', res.merchantField)
            resolve(res)
          })
          .catch(reason => reject(reason))
      })
    },


    // 登出
    Logout({ dispatch,commit, state }) {
      return new Promise((resolve) => {
        // commit('SET_TOKEN', '')
        // commit('SET_ROLES', [])
        // Vue.ls.remove(ACCESS_TOKEN)
        // Vue.ls.remove(USER_INFO_KEY)
        // Vue.ls.remove(ACCESS_VERSION_MESSAGE)
        // Vue.ls.remove(FOREIGN_CITY_LIST)
        // Vue.ls.remove(ACCESS_CLOUD_TOKEN)
        clearLocalInfo(commit)
        dispatch('GetGlobalCity').then(list => {
          if (list && list.length > 0) {
            console.log('GetGlobalCity===删除', list)
          } else {
            Vue.ls.remove(SET_CITY_FLAG)
            dbManager.GlobalCity.remove(1).catch(err => {
              console.error('dbManager', err)
            })
          }
        }).catch(error => {
          console.error('error', error)
          Vue.ls.remove(SET_CITY_FLAG)
          dbManager.GlobalCity.remove(1).catch(err => {
            console.error('dbManager', err)
          })
        })
        resolve()
      })
    },
    //清除本地数据（自动登录时使用）
    clearLocalData({ commit }) {
      return new Promise(resolve => {
        clearLocalInfo(commit)
        resolve()
      })
    }
  }
}

function clearLocalInfo(commit) {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  Vue.ls.remove(ACCESS_TOKEN)
  Vue.ls.remove(USER_INFO_KEY)
  Vue.ls.remove(ACCESS_VERSION_MESSAGE)
  Vue.ls.remove(FOREIGN_CITY_LIST)
  Vue.ls.remove(ACCESS_CLOUD_TOKEN)
  Vue.ls.remove('enterpriseId' )
  Vue.ls.remove('enterpriseName')
  clearProjectStorage('pro_')
}

export default user